<div *ngIf="entity" editorType="medium">
  <form *ngIf="form" [formGroup]="form">
    <div class="column">
      <dx-text-box [readOnly]="false" formControlName="code" formField required minlength="2"></dx-text-box>
      <dx-text-box [readOnly]="false" formControlName="productId" formField required></dx-text-box>
      <dx-text-box [readOnly]="false" formControlName="routeName" formField required></dx-text-box>
      <dx-text-box [readOnly]="false" formControlName="version" formField required></dx-text-box>
    </div>
  </form>
  <div class="controls">
    <dx-tab-panel class="tabs-content">
      <dxi-item class="mt-3" [title]="'entity.operations' | translate | ucfirst" dataType="string">
          <div *ngIf="operations" class="h-full flex flex-col gap-3">
            <!-- <div class="text-center mt-3">
              <dx-button class="border"  icon="add" (onClick)="add()"></dx-button>
            </div> -->
            <div *ngFor="let operation of operations"
                 class="h-full flex overflow-y-auto"
            >
              <div (click)="open(operation)" class="flex-1 border rounded p-3 cursor-pointer hover:bg-slate-200" >
                <div class="flex justify-between mb-1">
                  <div *ngIf="operation.operationTypeId !== undefined; else notypeId">
                    <div *ngFor="let type of allOperationTypes ">
                      <div *ngIf="type.id === operation.operationTypeId">
                        {{ type.name }} | {{type.mainColor}}
                      </div>
                    </div>
                  </div>
                  <ng-template #notypeId>There is no type operationn</ng-template>
                  <div>{{ operation.time }}</div>
                </div>
                <div class="mb-2"><span class="font-bold">{{ operation.name }}</span></div>

                <div *ngIf="operation.workCenters.length > 0; else noworkcenters" class="flex mb-1">
                  <span class="material-symbols-outlined flex" style="font-size: 1.5rem; margin-right: .5rem;">
                    precision_manufacturing
                  </span>
                  <div *ngFor="let workcenter of operation.workCenters" style="display: flex; align-items: center;">
                    <span *ngFor="let allworkcenter of allWorkcenters">
                      <span *ngIf="workcenter === allworkcenter.id" class="mr-2">{{ allworkcenter.name }}</span>
                    </span>
                  </div>
                </div>
                <ng-template #noworkcenters>
                  <div class="mb-1" style="display: flex; align-items: center;">
                    <span class="material-symbols-outlined flex" style="font-size: 1.5rem; margin-right: .5rem;">
                      precision_manufacturing
                    </span>
                    <div class="flex italic font-thin">There is no workcenters</div>
                  </div>
                </ng-template>

                <div *ngIf="operation.workForces.length > 0; else noworkforces" class="flex  mb-1">
                  <span class="material-symbols-outlined flex" style="font-size: 1.5rem; margin-right: .5rem;">
                    engineering
                  </span>
                  <div *ngFor="let workforce of operation.workForces" style="display: flex; align-items: center;">
                    <span *ngFor="let allworkforce of allWorkforces">
                      <span *ngIf="workforce === allworkforce.id" class="mr-2">{{ allworkforce.name }}</span>
                    </span>
                    {{ getWorkForceNameById(workforce.workForceId) }}
                  </div>
                </div>
                <ng-template #noworkforces>
                  <div class="mb-1" style="display: flex; align-items: center;">
                    <span class="material-symbols-outlined flex" style="font-size: 1.5rem; margin-right: .5rem;">
                      engineering
                    </span>
                    <div class="flex italic font-thin">There is no workforces</div>
                  </div>
                </ng-template>

                <div *ngIf="operation.equipments.length > 0; else noequipments" class="flex mb-1">
                  <span class="material-symbols-outlined flex" style="font-size: 1.5rem; margin-right: .5rem;">
                    construction
                  </span>
                  <div *ngFor="let equipment of operation.equipments" style="display: flex; align-items: center;">
                    <span *ngFor="let allequipment of allEquipments">
                      <span *ngIf="equipment === allequipment.id" class="mr-2">{{ allequipment.name }}</span>
                    </span>
                    {{ getEquipmentNameById(equipment.equipmentId) }}
                  </div>
                </div>
                <ng-template #noequipments>
                  <div class="mb-1" style="display: flex; align-items: center;">
                    <span class="material-symbols-outlined flex" style="font-size: 1.5rem; margin-right: .5rem;">
                      construction
                    </span>
                    <div class="flex italic font-thin">There is no equipments</div>
                  </div>
                </ng-template>

              </div>
              <div class="flex-initial">
                <dx-button icon="delete" [disabled]="true" ></dx-button>
              </div>
            </div>
          </div>

      </dxi-item>
    </dx-tab-panel>
  </div>
</div>

